import React, { useEffect } from 'react'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import LmsSlider from '../Components/LmsSlider'
import Aos from 'aos'

function Work() {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
    });
  }, []);
  return (
    <>
      <div className="main-div2">
        <Navbar />
        <div className='grid lg:grid-cols-2 md:grid-cols-1 grid-cols-1 xl:gap-0 gap-[20px] justify-between overflow-hidden items-center md:px-[100px] px-[20px] md:pt-[163px] pt-[100px]'>
          <div className='pt-[34px] flex md:justify-center'>
            <img data-aos="fade-right" src="/assets/a/img7.svg" alt="" />
          </div>
          <div className='md:px-[40px]'>
            <p className="font-[400] text-justify font-sans text-[16px] leading-[27px] text-[#263238]">GISUL crafts personalized learning solutions that cater to professionals, students, freshers, and anyone seeking to upskill and grow. Our expert-led programs are designed to develop essential skills, drive career advancement, and ensure measurable success. Whether you're looking to enhance your expertise, prepare for the job market, or stay ahead in your industry, GISUL provides the right learning path for long-term excellence and achievement.</p>
          </div>
        </div>
        <div className="grid md:grid-cols-2 md:px-[100px] md:pt-0 pt-[30px] items-start mb-[50px] px-[20px] grid-cols-1 gap-[20px]">
          <div className='flex items-center gap-[14px]'>
          <img src="/assets/a/img5.svg" alt="" />
          <img src="/assets/a/img6.svg" alt="" />
          <img src="/assets/a/img1.png" className='md:block hidden' alt="" />
          </div>
          <div>
            <img src="/assets/a/img4.svg" alt="" />
          </div>
        </div>
        <Footer />
      </div>
    </>
  )
}

export default Work